module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": "新建内容"
    },
    on: {
      "close": _vm._onClose
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-form', {
    ref: "dialogForm",
    attrs: {
      "label-width": "100px",
      "rules": _vm.rules,
      "model": _vm.content
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": !!_vm.content.id
    },
    model: {
      value: (_vm.content.type),
      callback: function($$v) {
        _vm.$set(_vm.content, "type", $$v)
      },
      expression: "content.type"
    }
  }, [_vm._v("图文")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": !!_vm.content.id
    },
    model: {
      value: (_vm.content.type),
      callback: function($$v) {
        _vm.$set(_vm.content, "type", $$v)
      },
      expression: "content.type"
    }
  }, [_vm._v("H5")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": !!_vm.content.id
    },
    model: {
      value: (_vm.content.type),
      callback: function($$v) {
        _vm.$set(_vm.content, "type", $$v)
      },
      expression: "content.type"
    }
  }, [_vm._v("链接")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类",
      "prop": "categoryId"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.content.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.content, "categoryId", $$v)
      },
      expression: "content.categoryId"
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.content.title),
      callback: function($$v) {
        _vm.$set(_vm.content, "title", $$v)
      },
      expression: "content.title"
    }
  })], 1), _vm._v(" "), (_vm.content.type == 3) ? _c('el-form-item', {
    attrs: {
      "label": "链接",
      "prop": "originalLink"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "http://"
    },
    model: {
      value: (_vm.content.originalLink),
      callback: function($$v) {
        _vm.$set(_vm.content, "originalLink", $$v)
      },
      expression: "content.originalLink"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.content.type == 3) ? _c('el-form-item', {
    attrs: {
      "label": "上传图片"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-upload', {
    attrs: {
      "name": "Filedata",
      "action": _vm.uploadUrl,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      "show-file-list": _vm.show_file_list,
      "on-success": _vm.success,
      "on-error": _vm.error
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "loading": _vm.loading,
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "摘要",
      "prop": "describe"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.content.describe),
      callback: function($$v) {
        _vm.$set(_vm.content, "describe", $$v)
      },
      expression: "content.describe"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1a3d0b41!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/newContentDialog.vue
// module id = 216
// module chunks = 29